export class RadioInput {
  trigger: HTMLElement | null = null
  radioContainerNode: HTMLElement | null = null
  radioNodes: NodeListOf<HTMLInputElement> | null = null

  constructor (radioContainerNode: HTMLElement) {
    this.radioContainerNode = radioContainerNode
    this.radioNodes = this.radioContainerNode.querySelectorAll('input[type="radio"]')

    this.radioNodes.forEach((radio) => {
      radio?.addEventListener('change', () => {
        if (radio.dataset?.uiEl === 'nfb-form-radio-collapsible-parent' && this.radioContainerNode?.dataset.collapsibleIsTriggered === 'false') {
          this.radioContainerNode.dataset.collapsibleIsTriggered = 'true'
        } else {
          this.radioContainerNode!.dataset.collapsibleIsTriggered = 'false'
        }
      })
    })
  }
}
